const variables = {
  DEFAULT_LOCALE: 'fa',
  LOCALE_COOKIE_NAME: 'cmslocale',
  RTL_COOKIE_NAME: 'cmsrtl',
};

export default variables;
